import { useContext, useEffect } from "react";
import { DashboardLayoutContext } from "contexts/DashboardLayoutContext";
import { PageID, TabID } from "codes/page";

export default function useDashboard(pageId?: PageID, tabId?: TabID) {
  const context = useContext(DashboardLayoutContext);

  useEffect(() => {
    if (pageId) {
      context.setPageId(pageId);
    }
    if (tabId) {
      context.setTabId(tabId);
    }
  }, []);

  return context;
}
